"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateShareUrl = void 0;
/* istanbul ignore file @preserve --no value to test */

const generateShareUrl = (kind, sharedUrl) => {
  switch (kind) {
    case 'facebook':
      return `https://facebook.com/sharer/sharer.php?u=${sharedUrl}`;
    case 'vkontakte':
      return `http://vk.com/share.php?title=${document.title}&url=${sharedUrl}`;
    case 'email':
      return `mailto:?subject=${document.title}&body=${sharedUrl}`;
    case 'twitter':
      return `https://twitter.com/intent/tweet?text=${sharedUrl}`;
    default:
      return '';
  }
};
exports.generateShareUrl = generateShareUrl;
